const manutencao_sequencia_de_geracao_de_estimativa = {
  path: "/manutencao-de-sequencia-de-geracao-de-estimativa",
  redirect: "/manutencao-de-sequencia-de-geracao-de-estimativa",
  meta: {
    breadCrumb:
      "Planejamento de Matrícula - Manutenção de Sequência de Geração de Estimativa",
  },
  children: [
    {
      path: "/manutencao-de-sequencia-de-geracao-de-estimativa",
      name: "manutencao-de-sequencia-de-geracao-de-estimativa",
      component: () =>
        import(
          "@/views/ManutencaoDeSequenciaDeGeracaoDeEstimativa/ManutencaoDeSequenciaDeGeracaoDeEstimativaHome.vue"
        ),
    },
    {
      path: "/manutencao-de-sequencia-de-geracao-de-estimativa-novo",
      name: "manutencao-de-sequencia-de-geracao-de-estimativa-novo",
      component: () =>
        import(
          "@/views/ManutencaoDeSequenciaDeGeracaoDeEstimativa/ManutencaoDeSequenciaDeGeracaoDeEstimativaCad.vue"
        ),
    },
    {
      path: "/manutencao-de-sequencia-de-geracao-de-estimativa/edit/:id",
      name: "manutencao-de-sequencia-de-geracao-de-estimativa-edit",
      component: () =>
        import(
          "@/views/ManutencaoDeSequenciaDeGeracaoDeEstimativa/ManutencaoDeSequenciaDeGeracaoDeEstimativaEdit.vue"
        ),
    },
  ],
};

export { manutencao_sequencia_de_geracao_de_estimativa };
